import { request } from './request'

function fetchBannerList () {
  return request({
    method: 'GET',
    url: '/api/v1/shop/banner/8'
  })
}

function fetchCategories (pageIndex = 0, pageSize = 0) {
  return request({
    method: 'GET',
    url: '/api/v1/shop/catalogs',
    params: { pageIndex, pageSize }
  })
}

function fetchHotSaleProducts () {
  return request({
    method: 'GET',
    url: '/api/v1/shop/products',
    params: {
      pageIndex: 0,
      pageSize: 20,
      close: 1,
      labelId: 9
    }
  })
}

function fetchHomeProducts (pageIndex = 0, pageSize = 20) {
  return request({
    method: 'GET',
    url: '/api/v1/shop/products',
    params: {
      pageIndex,
      pageSize,
      close: 1,
    }
  })
}

function fetchProduct (productId) {
  return request({
    method: 'GET',
    url: `/api/v1/shop/products/${productId}`
  })
}

function fetchProductV2 (productId) {
  return request({
    method: 'GET',
    url: `/api/v2/shop/products/${productId}`
  })
}

// 这里暂时只有fetchHomeProducts在v2被用到，
const mall = {
  fetchBannerList,
  fetchProduct,
  fetchProductV2,
  fetchCategories,
  fetchHotSaleProducts,
  fetchHomeProducts
}

export default mall